<div id="formContainer">
    <form
        #ticketForm="ngForm"
        class="internal-form"
        appCheckFormInit
        [ngForm]="ticketForm"
        [ngClass]="{ 'form-submitted': formService.isSubmitted, 'form-fields-with-rules': isFormFieldsWithRules }"
        id="newTicketForm">
        @for (formField of form.fields; track formField) {
            <sb-form-field
                [formField]="formField"
                [formType]="formType"
                [templateRef]="attachmentsBlockTemplate"
                [class.highlighted]="formField.isDependant && formField.isShowedBecauseOfRule"
                appCheckFieldRules
                [isRulesSupported]="isFormFieldsWithRules"
                [field]="formField"
                [fields]="form.fields"
                [attachments]="attachments"
                [formLanguage]="form.language">
            </sb-form-field>
        }
    </form>
</div>
